export default __webpack_public_path__ + "static/media/chevron-white-right.f55ec700.svg";